'use client'

import {
  background,
  BackgroundColorProps,
  border,
  BorderProps,
  color,
  ColorProps,
  compose,
  css,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
} from '@wrisk/styled-system'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

import { transition, TransitionProps } from '../../transition'
import { collapse, CollapseProps } from '../containers/collapse'
import { containerStyle, ContainerStyleProps } from './containerStyle'
import { displayOn, DisplayOnProps } from './displayOn'
import { gap, GapProps } from './gap'

export type BoxProps = BackgroundColorProps &
  BorderProps &
  ColorProps &
  ContainerStyleProps &
  DisplayOnProps &
  FlexboxProps &
  GapProps &
  GridProps &
  LayoutProps &
  PositionProps &
  PropsWithChildren &
  SpaceProps &
  TransitionProps &
  CollapseProps

export const Box = styled.div<BoxProps>(
  css({
    borderColor: 'divider',
    borderStyle: 'solid',
    borderWidth: 0,
  }),
  containerStyle,
  displayOn,
  compose(
    background,
    border,
    color,
    flexbox,
    gap,
    grid,
    layout,
    position,
    space,
    transition,
    collapse,
  ),
)
